import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { FacebookService, UIParams, UIResponse } from 'ngx-facebook';
import { FbService, ShareMessagesService, UtilService, VariablesService } from '../../../../shared/services';

@Component({
  selector: 'app-fb-share',
  templateUrl: './fb-share.component.html',
  styleUrls: ['./fb-share.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FbShareComponent {

  @Input() public label;
  @Input() public count;
  @Input() public campaign_url;
  @Input() public utm_params;
  @Input() public backgroudColor = '#3b5998';
  @Input() public color = '#ffffff';
  @Input() public fundraiser;
  @Input() public position;
  @Input() public buttonType = 'square';
  @Input() public shareType = 'default';
  @Input() private userData;
  isLoading;

  shareUrl;
  utmData = {
    source: 'internal',
    medium: 'fbpageshare',
    campaign_name: ''
  };

  constructor(
    public fb: FacebookService,
    public shareMessagesService: ShareMessagesService,
    public utilService: UtilService,
    public fbService: FbService,
    public variablesService: VariablesService,
    private cdr: ChangeDetectorRef
  ) { }

  /**Face book share */
  async facebookShare() {
    this.isLoading = true;
    this.isLoading = await this.fbService.scriptLoaderFB();
    this.cdr.detectChanges();
    this.shareMessagesService.shareEvents('fb share', this.position);
    let url;
    let message;
    if (this.shareType === 'portfolio') {
      // tslint:disable-next-line:max-line-length
      message = `I have started giving monthly. Just like me, you can also make this world a healthier and happier place by giving a little every month. Visit link to create a positive impact in the society.`;
      url = `${this.utilService.domain_details.domain_url}/new/portfolio/welcome?${this.userData ? this.userData.full_name : ''}`;
    } else if (this.shareType === 'eventPage') {
      message = `This pandemic has affected us all but it has been even harsher on the underprivileged. While we get upset when we are unable to order our favourite food, some people out there have been hungry for days. Many daily wage workers, labourers and helpers have lost their only source of income and are unable to sustain their families. A little help from you can go a long way providing them with decent meals for their family.`;
      url = `${this.utilService.domain_details.domain_url}${this.variablesService.milkarMumbai}`;
    } else {
      let pageName = 'fundraiser';
      if (this.variablesService.fundraiser.support_campaign) {
        pageName = 'supportfundraiser';
      }
      const page = this.variablesService.campaignType === 'stories' ? 'stories' : pageName;
      url = `${this.utilService.domain_details.domain_url}/${page}/${this.variablesService.fundraiser.custom_tag}`;
      this.utmData.campaign_name = this.variablesService.fundraiser.custom_tag;
    }
    const params: UIParams = {
      href: `${this.shareMessagesService.getLinkWithUtmTags(url, this.utmData)}`,
      method: 'share',
      message: message || ''
    };
    this.fb.ui(params).then((res: UIResponse) => { }).catch((e: any) => { });
  }
}
